import { SET_THEME, TOGGLE_THEME, SET_THEME_VARIANT } from '../actions/themeActions';


const initialState = {
  mode: localStorage.getItem('appThemeMode') || 'light',
  variant: localStorage.getItem('appThemeVariant') || 'default'
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
     
      localStorage.setItem('appThemeMode', action.payload);
      return {
        ...state,
        mode: action.payload
      };
    
    case TOGGLE_THEME:

      const newMode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('appThemeMode', newMode);
      localStorage.setItem('appThemeVariant', 'default');
      return {
        ...state,
        mode: newMode,
        variant: 'default'
      };

    case SET_THEME_VARIANT:
      localStorage.setItem('appThemeVariant', action.payload);
      return {
        ...state,
        variant: action.payload
      };
    
    default:
      return state;
  }
};

export default themeReducer; 